import { ACCEPT_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import mixpanel from 'root/src/client/logic/analytics/mixpanel'
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel'

export default formData => async (dispatch, getState) => {
	const state = getState()
	const projectUrl = currentRouteParamsRecordId(state)
	const apiPayload = {
		...formData,
		projectUrl,
	}
	const res = await dispatch(apiRequest(ACCEPT_PROJECT, apiPayload))
	const { error } = res
	if (error) {
		const { message } = error
		throw { daysToExpire: message }
	} else {
		mixpanel.track(mixpanelEvents.dareClaim, { ...formData })
		return res
	}
}
